import * as React from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Icon } from "antd";
import "./MsSider.scss";

// 侧边栏props类型接口定义
interface SiderProps {
  [key: string]: any
}

// 侧边栏state类型接口定义
interface SiderState {
  collapsed: boolean
}

type AllProps = SiderProps;

// 类型名称声明
const { Sider } = Layout;

/**
 * 侧边导航组件定义，设置导航
 * 1、可设置展开关闭属性
 *
 * @class MsSider
 * @extends {React.Component}
 */
class MsSider extends React.Component<AllProps, SiderState> {
  // 构造函数，初始化state
  constructor(props: AllProps) {
    super(props);

    // state设置
    this.state = {
      collapsed: false
    }
  }

  // 设置sider关闭展开
  public onCollapse = (collapsed: boolean) =>  {
    this.setState({ collapsed });
  }

  // 渲染
  public render() {
    return (
      <Sider
        collapsible={true}
        collapsed={this.state.collapsed}
        onCollapse={this.onCollapse}
        className="sider-pay"
      >
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["ms-pay-list"]}
          style={{ height: "100%"}}>
          <Menu.Item key="ms-pay-list" className="sider-pay-item">
            <Link to="/ms-pay-list">
              <Icon type="audit" />
              <span>收入发放</span>
            </Link>
          </Menu.Item>
        </Menu>
      </Sider>
    )
  }
}

export default MsSider;



// WEBPACK FOOTER //
// ./src/components/ms-layout/ms-sider/MsSider.tsx